var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-box"},[_c('div',{staticClass:"footer"},[_c('div',{staticClass:"sign"},[_c('span',{staticClass:"system-title"},[_vm._v("-城市合伙人管理系统-")]),_vm._v(" 开发单位：合肥足行体育科技有限公司 ")])])])
}]

export { render, staticRenderFns }